import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_CORRECTION_LETTER_',
  }
);

export interface FetchCorrectionLetterState {
  data: string | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCorrectionLetterRequestAction {
  id: number;
  onSuccess?: (url: string) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: string;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCorrectionLetterState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCorrectionLetterState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchCorrectionLetterState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchCorrectionLetterState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCorrectionLetterState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCorrectionLetter = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCorrectionLetterTypes = Types;
export const FetchCorrectionLetterActions = Creators;
